const locale = {
	// #region User Dashboard
	WELCOME: 'Welcome back,',
	PROFILE_LINK: 'Go to your profile ',

	TAB_HOME: 'Home',
	TAB_STATS: 'Stats',
	TAB_LEADS_MAP: 'Leads map',
	TAB_DAILYWORKREPORTS: 'Daily WorkReports',
	TAB_ORDERS_BILLING: 'Orders Billing',
	TAB_ACTIVITIES_OVERVIEW: 'Activities overview',
	TAB_OPPORTUNITIES_OVERVIEW: 'Opportunities overview',
	TAB_ORDERS_OVERVIEW: 'Orders overview',
	TAB_OPPORTUNITIES_STATS: 'Opportunities stats',
	TAB_ORDERS_STATS: 'Orders stats',

	FAST_ACTIONS_WIDGET_TITLE: 'Fast actions',
	LINKS_WIDGET_TITLE: 'Links',

	TOT_VALUE: 'Tot value: {value}',

	WIDGET_YESTERDAY: 'Yesterday',
	WIDGET_TODAY: 'Today',
	WIDGET_TOMORROW: 'Tomorrow',
	WIDGET_NEXT_7_DAYS: 'Next 7 days',
	WIDGET_NEXT_30_DAYS: 'Next 30 days',

	WIDGET_LAST_WEEK: 'Last week',
	WIDGET_THIS_WEEK: 'This week',
	WIDGET_LAST_MONTH: 'Last month',
	WIDGET_THIS_MONTH: 'This month',
	WIDGET_THIS_YEAR: 'This year',
	WIDGET_LAST_YEAR: 'Last year',
	WIDGET_ALL: 'All',
	// #endregion

	// #region Dashboard Stats table
	DASHBOARD_STATS_TABLE_NO_VALUE: 'Non definito',
	// #endregion

	// #region Dashboard Opportunities stats tab
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_DATE_TO_MONTHYEAR: 'Mese fine',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_RATING: 'Temperatura',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_USER_ASSIGNED: 'Utente assegnato interno',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_COMPANY: 'Azienda',

	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_TOT_OPEN: 'N. totale',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_TOT_QUOTATIONS: 'N. proposte',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_TOT_SIGNED: 'N. vinte',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_TOT_VALUE_QUOTATIONS: 'Valore proposte',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_TOT_VALUE_DEFINITIVE: 'Valore vinte',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_AVG_TIME_QUOTE_TO_ORDER: 'Tempo attraversamento medio',
	DASHBOARD_OPPORTUNITIES_STATS_COLUMN_AVG_SUCCESS_RATE: 'Percentuale conversione',

	DASHBOARD_OPPORTUNITIES_STATS_FOOTER_TOT_VALUE_QUOTATIONS: 'Totale valore proposte: {value}',
	DASHBOARD_OPPORTUNITIES_STATS_FOOTER_TOT_VALUE_DEFINITIVE: 'Totale valore vinte: {value}',
	// #endregion

	// #region Dashboard Orders stats tab
	DASHBOARD_ORDERS_STATS_COLUMN_DATE_SIGN_MONTHYEAR: 'Mese firma',
	DASHBOARD_ORDERS_STATS_COLUMN_USER_ASSIGNED: 'Utente assegnato interno',
	DASHBOARD_ORDERS_STATS_COLUMN_COMPANY: 'Azienda',

	DASHBOARD_ORDERS_STATS_COLUMN_TOT_OPEN: 'N. totale',
	DASHBOARD_ORDERS_STATS_COLUMN_TOT_QUOTATIONS: 'N. proposti',
	DASHBOARD_ORDERS_STATS_COLUMN_TOT_SIGNED: 'N. firmati',
	DASHBOARD_ORDERS_STATS_COLUMN_TOT_VALUE_QUOTATIONS: 'Valore proposti',
	DASHBOARD_ORDERS_STATS_COLUMN_TOT_VALUE_DEFINITIVE: 'Valore firmati',
	DASHBOARD_ORDERS_STATS_COLUMN_AVG_TIME_QUOTE_TO_ORDER: 'Tempo attraversamento medio',
	DASHBOARD_ORDERS_STATS_COLUMN_AVG_SUCCESS_RATE: 'Percentuale conversione',

	DASHBOARD_ORDERS_STATS_FOOTER_TOT_VALUE_QUOTATIONS: 'Totale valore proposti: {value}',
	DASHBOARD_ORDERS_STATS_FOOTER_TOT_VALUE_DEFINITIVE: 'Totale valore vinti: {value}'
	// #endregion
};

export default locale;
